import { Currency } from '../Currency.enum'

function getLabel(val: Currency) {
  switch (val) {
    case Currency.IDR:
      return 'Indonesia Rupiah'
    case Currency.JPY:
      return 'Japan Yen'
    default:
      return '?'
  }
}

function getSymbol(val: Currency) {
  switch (val) {
    case Currency.IDR:
      return 'Rp'
    case Currency.JPY:
      return '¥'
    default:
      return '?'
  }
}

const CurrencyEnumHelper = {
  getLabel,
  getSymbol,
}

export default CurrencyEnumHelper
